// config.js
export const CONFIG = {
    defaultProofingPhase: 'Hamburgers',
    fontFormats: {
      truetype: 'ttf',
      opentype: 'otf',
    },
    jsonPath: 'src/js/proof.json',
  };